module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9HHbY"))).then(() => parcelRequire('d0iPb'));